
import React from 'react';

export type MemberRole = 'Primary Owner' | 'Owner' | 'Manager';

export type MemberStatus = 'active' | 'invited';

// Using Zod-inferred type for permissions to ensure compatibility
import { PortfolioMemberPermission } from '../../../../schemas/portfolio'; // Corrected import path
export type MemberPermission = PortfolioMemberPermission; // Alias if needed, or use directly

// export interface MemberPermission { // Old interface, replaced by Zod type
//   id: string;
//   name: string;
//   checked: boolean;
//   description?: string; // Optional description property
// }

export interface Member {
  id: string;
  userId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role: MemberRole;
  permissions?: PortfolioMemberPermission[]; // Use Zod-inferred type
  status: MemberStatus;
  isCurrentUser: boolean;
  avatarUrl?: string;
  avatarInitials?: string;
  userExists?: boolean;
  invitedAt?: Date;
  joinedAt?: Date;
  invitedBy?: string;
  portfolios?: string[];
}

export interface InviteMemberFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role: string;
  permissions: MemberPermission[];
  setFormField: (field: string, value: any) => void;
}

// Updated permission options to match the requested structure
export const permissionOptions: MemberPermission[] = [
  {
    id: 'viewOnly',
    name: 'View Only',
    description: 'Can only view information, cannot make changes',
    checked: false
  },
  {
    id: 'portfolioUsers',
    name: 'Edit Users (Portfolio)',
    description: 'Can add, edit, and remove portfolio users',
    checked: false
  },
  {
    id: 'portfolioSettings',
    name: 'Edit Settings',
    description: 'Can modify portfolio settings',
    checked: false
  },
  {
    id: 'campaigns',
    name: 'Edit Campaign',
    description: 'Can manage business campaigns',
    checked: false
  },
  {
    id: 'budget',
    name: 'Edit Budget',
    description: 'Can adjust budget settings',
    checked: false
  },
  {
    id: 'billing',
    name: 'Edit Billing',
    description: 'Can manage billing settings',
    checked: false
  },
  {
    id: 'leads',
    name: 'Edit Leads',
    description: 'Can manage leads',
    checked: false
  },
  {
    id: 'businessUsers',
    name: 'Edit Users (Businesses)',
    description: 'Can manage business team members',
    checked: false
  }
];
